'use client';

import { FormattedMessage } from 'react-intl';
import Typography from '@alltrails/core/components/Typography';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import Button from '@alltrails/denali/components/Button';
import Heading from '@alltrails/denali/components/Heading';
import Link from '@alltrails/denali/components/Link';
import useIsMobileSizedScreen from '@alltrails/denali/hooks/useIsMobileSizedScreen';
import FacebookIcon from '@alltrails/layout/components/socialIcons/FacebookIcon';
import InstagramIcon from '@alltrails/layout/components/socialIcons/InstagramIcon';
import LinkedInIcon from '@alltrails/layout/components/socialIcons/LinkedInIcon';
import TikTokIcon from '@alltrails/layout/components/socialIcons/TikTokIcon';
import TwitterIcon from '@alltrails/layout/components/socialIcons/TwitterIcon';
import PressAssetRequestNote from '@/components/shared/PressAssetRequestNote/PressAssetRequestNote';
import styles from './styles.module.scss';

const br = () => <br />;

export default function NewsRoomContactUs() {
  const isMobile = useIsMobileSizedScreen();
  const languageRegionCode = useLanguageRegionCode();
  const imageFileName = `https://cdn-assets.alltrails.com/press/contact_us/PR-KIT-IMG-${languageRegionCode}${isMobile ? '-M' : '-D'}`;

  return (
    <>
      <div className={styles.dividerWrapper}>
        <hr className={styles.divider} />
      </div>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.left}>
            <Heading as="h2" className={styles.header} size="500">
              <FormattedMessage defaultMessage="Contact us" />
            </Heading>

            <div className={styles.info}>
              <div>
                <Heading as="h3" className={styles.subHeader} size="400">
                  <FormattedMessage defaultMessage="Press contact" />
                </Heading>
                <Link className={styles.email} href="mailto:press@alltrails.com">
                  <FormattedMessage defaultMessage="Email" />
                </Link>
                <PressAssetRequestNote className={styles.assetRequest} />
              </div>
              <div>
                <Heading as="h3" className={styles.subHeader} size="400">
                  <FormattedMessage defaultMessage="Address" />
                </Heading>
                <Typography component="div" variant="paragraph200">
                  <p className={styles.address}>
                    530 Bush Street, 9th Floor <br /> San Francisco, CA, 94108
                  </p>
                  <div className={styles.links}>
                    <LinkedInIcon openInNewTab />
                    <FacebookIcon openInNewTab />
                    <InstagramIcon openInNewTab />
                    <TikTokIcon openInNewTab />
                    <TwitterIcon openInNewTab />
                  </div>
                </Typography>
              </div>
            </div>
          </div>
          <div className={styles.download}>
            <picture>
              <source srcSet={`${imageFileName}.avif`} type="image/avif" />
              <source srcSet={`${imageFileName}.webp`} type="image/webp" />
              <img className={styles.img} loading="lazy" src={`${imageFileName}.jpg`} alt="" />
            </picture>
            <div className={styles.presskit}>
              <Heading as="h2" className={styles.pressText} size="500">
                <FormattedMessage defaultMessage="Download <br></br> our press kit" values={{ br }} />
              </Heading>
              <Button
                linkInfo={{
                  href: 'https://www.dropbox.com/scl/fo/g0rqlov7junzuljyjk8uw/ADFx0onwClg9g0aOb0r2nNA?rlkey=90qesjadcvk95dryzo7ho85yw&st=bbeeaedn&dl=0',
                  target: '_blank'
                }}
                text={<FormattedMessage defaultMessage="View assets" />}
                variant="ghost"
                elevated
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
